import styled from 'styled-components'
import { MavenTheme } from '../../styles/interfaces'

export const DoormanInfoStyled = styled.div<{ theme: MavenTheme }>`
  display: grid;
  grid-template-columns: 697px 363px;
  column-gap: 30px;
`
